<template>
<div class="page_smart_park">
	<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
		<div class="cardlist">
			<div class="item" v-for="item in dataList" :key="item.id">
				<div class="item_l" @click="toDetail(item)">
					<div class="">卡名：{{ item.times_card.name }}</div>
					<div class="">已用次数：{{ item.used_times }}次</div>
					<div class="">总次数：{{ item.times }}次</div>
					<div class="">是否通票：{{ item.times_card.is_through_ticket ? '是' : '否' }}</div>
					<div class="" v-if="item.smarkpark">园区：{{ item.smarkpark.title }}</div>
					<div class="" v-if="item.venue">场馆：{{ item.venue.title }}</div>
				</div>
			</div>
		</div>
	</van-list>
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import PageSearch from "../../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
            publicPath: process.env.BASE_URL,
			loading: true,
			finished: false,
			dataList: [],
			pages: {
				page: 1,
				size: 10
			},
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '次卡订单',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
						this.getData()
                    } else {
                        this.token = "";
                    }
                    // 调用某方法
					
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
			this.getData()
        }
		
    },
	mounted() {
	},
    methods: {
		// 获取订单数据
		getData(){
			var that = this
			var params = {
				token: that.token,
				page: that.pages.page,
				size: that.pages.size,
			}
			that.$api.smartpark.usertimescardlist(params).then(res=>{
				if(res.code == 200){
					var list = res.result
					if(list.length != 0){
						for(var i in list){
							that.dataList.push(list[i])
						}						
					}else{
						that.finished = true
					}
					that.pages.page++
					that.loading = false
				}else{
					that.finished = true
				}
			})
		},
        // 详情
		toDetail(order){
			var that = this
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/my/smartpark/carddetail?order_sn='+order.order_sn+'&times_card_id='+order.times_card_id
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
			} else {
				that.$router.push({
					path: '/my/smartpark/carddetail',
					query: {
						order_sn: order.order_sn,
                        times_card_id: order.times_card_id
					}
				})
			}
		},
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
